import { useMobileDocumentScrollLock } from '@/mobile/platform/useMobileDocumentScrollLock'

/** Evita rubber-band y drift del documento mientras el shell móvil Nutri-Matic está montado. */
export function useNutrimaticMobileScrollLock(active = true) {
  useMobileDocumentScrollLock(active, 'nutrimatic')
}
